import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Button } from 'blaze-ui/Button'
import { Check2 } from 'blaze-ui/icons'

interface Props {
  notificationId: number
}

export const MarkAsReadButton = observer(({ notificationId }: Props) => {
  const { notifications } = useRootStore()
  const currentWorkspace = useCurrentWorkspace()

  const markAsRead = async () => {
    if (!currentWorkspace) return null

    notifications.markAsRead(notificationId, currentWorkspace.key)
  }

  return (
    <Button size="sm" variant="secondary" frontIcon={Check2} onPress={markAsRead}>
      Archive
    </Button>
  )
})
